@if (currency$ | async; as currency) {
  @if (displayCurrency.selectedRate(); as rate) {
    <span
      class="inline-flex flex-col leading-tight"
      [class.items-end]="stackAlign === 'end'"
      [class.items-center]="stackAlign !== 'end'"
      [ngClass]="youPayWrapperClasses"
    >
      <span
        [class.line-through]="discount"
        [class.font-bold]="bold"
        [class.font-semibold]="semiBold"
        [class.font-normal]="!format && !semiBold && !bold"
        [class.text-neutral-600]="discount"
        [class.kiosk:text-inherit]="discount"
        [style.color]="priceColor | contentBuilderColor"
        [style.text-shadow]="priceTextShadow"
        [ngClass]="priceLineClasses"
        class="notranslate lining-nums tabular-nums whitespace-nowrap"
        [class.font-base]="!format"
      >
        @if (withParenthesis) {
          (
        }
        @if (displayPlus && amount >= 0) {
          <span>+</span>
        }
        ≈ {{ formatForeignPrice(amount, rate) }}
        @if (withParenthesis) {
          )
        }
      </span>
      <span
        class="whitespace-nowrap font-normal"
        [ngClass]="legalLineClasses"
      >
        @if (legalCaption === 'youPay') {
          {{ 'kiosk.currency.you-pay' | translate: { amount: formatLegalPrice(amount, currency) } }}
        } @else {
          {{ formatLegalPrice(amount, currency) }}
        }
      </span>
    </span>
  } @else if (!format) {
    <span
      [class.line-through]="discount"
      [class.font-bold]="bold"
      [class.font-semibold]="semiBold"
      [class.font-normal]="!semiBold && !bold"
      [class.text-neutral-600]="discount"
      [class.kiosk:text-inherit]="discount"
      [style.color]="priceColor | contentBuilderColor"
      [style.text-shadow]="priceTextShadow"
      [ngClass]="{
        'text-sm lg:text-base': size === 'SM',
        'text-md': size === 'MD',
        'text-lg': size === 'L',
        'text-xl': size === 'XL',
        'text-2xl': size === '2XL',
        'text-3xl': size === '3XL',
        'text-4xl': size === '4XL',
      }"
      [class]="size"
      class="notranslate font-base font-normal lining-nums tabular-nums whitespace-nowrap"
    >
      @if (withParenthesis) {
        (
      }
      @if (displayPlus && amount >= 0) {
        <span>+</span>
      }
      {{ formatPrice(amount, currency, false) }}
      @if (withParenthesis) {
        )
      }
    </span>
  } @else {
    <span
      [class.line-through]="discount"
      [class.font-bold]="bold"
      [class.font-semibold]="semiBold"
      [class.text-neutral-600]="discount"
      [class.kiosk:text-inherit]="discount"
      [style.text-shadow]="priceTextShadow"
      [ngClass]="{
        'text-sm': size === 'SM',
        'text-md': size === 'MD',
        'text-lg': size === 'L',
        'text-xl': size === 'XL',
        'text-2xl': size === '2XL',
        'text-3xl': size === '3XL',
        'text-4xl': size === '4XL',
        'text-base': !size,
      }"
      [class]="size"
      class="notranslate lining-nums tabular-nums whitespace-nowrap"
    >
      @if (withParenthesis) {
        (
      }
      {{ formatPrice(amount, currency, true) }}
      @if (withParenthesis) {
        )
      }
    </span>
  }
}
